import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFaculty = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M7.84766 3.80435C8.73645 2.84577 10.2226 2.5 12.5729 2.5C17.1379 2.5 18.4422 3.80435 18.4422 8.36956C18.4422 12.9348 17.0877 14.2391 12.5729 14.2391C12.3476 14.2391 12.1302 14.2359 11.9204 14.2291",
			stroke: "#8A94A6",
			strokeWidth: 1.33333,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.8333 10.834H12.4999",
			stroke: "#8A94A6",
			strokeWidth: 1.33333,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.8333 5.83398H13.3333",
			stroke: "#8A94A6",
			strokeWidth: 1.33333,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.8333 8.33398H14.9999",
			stroke: "#8A94A6",
			strokeWidth: 1.33333,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M5.41668 10.834C7.02718 10.834 8.33333 9.71442 8.33333 8.33398C8.33333 6.953 7.02718 5.83398 5.41668 5.83398C3.80618 5.83398 2.50002 6.953 2.50002 8.33398C2.49423 9.70945 3.79138 10.829 5.39609 10.834H5.41668Z",
			stroke: "#8A94A6",
			strokeWidth: 1.33333,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M5.41659 17.5C2.94475 17.5 0.833252 17.1047 0.833252 15.5221C0.833252 13.9394 2.93114 12.5 5.41659 12.5C7.88842 12.5 9.99992 13.9257 9.99992 15.5077C9.99992 17.0896 7.90203 17.5 5.41659 17.5Z",
			stroke: "#8A94A6",
			strokeWidth: 1.33333,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgFaculty);
export { ForwardRef as ReactComponent };
